// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"9b597e96","703":"29b0c957","787":"d646480e"}[chunkId] + ".chunk.js";
};